module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "tabs-view"
  }, [_c('TabBar', {
    attrs: {
      "tabs": _vm.tabItemList
    },
    on: {
      "on-change": _vm.onChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "50px",
      "padding": "0 10px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.currentView))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-2e29f59f!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/tabsView.vue
// module id = 227
// module chunks = 0